webpackJsonp([72],{

/***/ 1624:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(824);


/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(98);

var _datetime2 = _interopRequireDefault(_datetime);

var _nl = __webpack_require__(570);

var _nl2 = _interopRequireDefault(_nl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('nl', _nl2.default);

/***/ })

},[1624]);


// WEBPACK FOOTER //
// app/datetime.nl-073b734d73f79123d2df.js